// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3g1nQ","label":"Category_label__2fvsS","content":"Category_content__2wJ_A","header":"Category_header__JRrjW","location":"Category_location__1mluJ"};